<template>
    <div class="register-page">
        <RegisterForm />
    </div>
</template>

<script>
import RegisterForm from "@/components/RegisterForm.vue";

export default {
    name: "RegisterPage",
    components: {
        RegisterForm,
    },
};
</script>

<style scoped>
.register-page {
    display: flex;
    justify-content: center;
    /* Horizontally center the form */
    align-items: center;
    /* Vertically center the form */
    height: 100vh;
    /* Full viewport height to center vertically */
    background-color: #f9f9f9;
    /* Optional background color for contrast */
    padding: 1rem;
    /* Add padding for smaller screens */
}

h1 {
    margin-bottom: 2rem;
    font-size: 2rem;
    color: #333;
    text-align: center;
}
</style>